import {
  AppBar,
  Box,
  Typography,
  Badge,
  IconButton,
  Popover,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Logo from "./Logo";
import aiIcon from "../../assets/Icons/calendar.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import box from "../../assets/Icons/box.svg";
import wallet from "../../assets/Icons/Wallet.svg";
import sellIcon from "../../assets/Icons/shop.svg";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../store/userSlice";
import Drawers from "./Drawers";
import { gql, useQuery } from "@apollo/client";

import useGetCart from "../../Hooks/useGetCart";
import useGetServiceCart from "../../Hooks/useGetServiceCart";
import useGetFav from "../../Hooks/useGetFav";
import FullSearchBar from "../Search/FullSearchBar";
import CartDrawer from "../Cart/CartDrawer";

import { FiUser } from "react-icons/fi";
import { COLORS } from "../../STYLES/color";
import { FaChevronDown } from "react-icons/fa6";
import { MdOutlineLogout } from "react-icons/md";
import WishlistDrawer from "../Cart/wishlist/wishlist-drawer";
import PostalCode from "./PostalCode";
import EnhancedSearchDropdown from "../Search/EnhancedSearchDropdown";
import shoppingCartIcon from "../../assets/Icons/shopping_cart.svg";
import wishListIcon from "../../assets/Icons/fave.svg";
import loginIcon from "../../assets/Icons/user-login.svg";
import useAuthFlow from "../../Hooks/use-auth-flow";

export const CartActionBadge = styled("span")(({ theme }) => ({
  position: "absolute",
  top: -12,
  right: -7,
  minWidth: 15,
  height: 15,
  borderRadius: "50%",
  background: "#743186",
  color: "#FFFFFF",
  border: "2px solid #2E1834",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "8px",
  fontWeight: 700,
  lineHeight: 1,
  boxShadow: "0 8px 18px rgba(0, 0, 0, 0.18)",
}));

const GET_CART_ITEMS = gql`
  query GetCartItems {
    cartItems @client
  }
`;
const GET_SERVICE_CART = gql`
  query GetServiceItems {
    serviceCarts @client
  }
`;
const GET_FAV_CART = gql`
  query GetFavItems {
    favItemsVar @client
  }
`;

const APP_STORE_URL = "https://apps.apple.com/ng/app/mamaket-mobile/id6469295262";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.mamaket.mobile2026";

const Navbar = ({ mini }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [query, setQuery] = useState("");

  const favProducts = useSelector((state) => state.favourite);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isSeller = useSelector(
    (state) => state.user?.user?.profile?.hasPaidMembershipFee,
  );
  const theme = useTheme();
  const userInfo = useSelector((state) => state.user?.user?.profile);

  const { loading, data, error } = useQuery(GET_CART_ITEMS);
  const { data: serviceCart } = useQuery(GET_SERVICE_CART);
  const { data: favItems } = useQuery(GET_FAV_CART);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [cartDrawerOpen, setCartDrawerOpen] = React.useState(false);
  const [wishDrawer, setWishDrawer] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    navigate("/");
    setAnchorEl(null);
    dispatch(logoutUser());
  };

  const handleCartDrawerOpen = () => {
    setCartDrawerOpen(true);
  };
  const handleWishDrawerOpen = () => {
    setWishDrawer(true);
  };

  const handleCartDrawerClose = () => {
    setCartDrawerOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { handleGetCart, refetch } = useGetCart();
  const { handleGetCart: handleServiceCart, refetch: refecthCart } =
    useGetServiceCart();

  const { handleGetFav, refetch: favRefetch } = useGetFav();

  useEffect(() => {
    handleGetCart();
    refetch();
    handleServiceCart();
    refecthCart();
    favRefetch();
    handleGetFav();
  }, []);

  const getCartCount = () => {
    if (!isAuthenticated) return 0;
    return (
      (data?.cartItems?.length || 0) + (serviceCart?.serviceCarts?.length || 0)
    );
  };

  const cartCount = getCartCount();

  const { triggerAuth } = useAuthFlow();

  // Profile management is now handled by ProfileProvider
  const handleDownloadApp = (event) => {
    event.preventDefault();

    const userAgent =
      typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isMac = /macintosh|mac os x/.test(userAgent);
    const targetUrl = isIOS || isMac ? APP_STORE_URL : PLAY_STORE_URL;

    window.open(targetUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <AppBar
        sx={{
          bgcolor: "#fff",
          boxShadow: "none",
          height: { md: "80px", sm: "auto", xs: "auto" },
        }}
      >
        {isMobile ? (
          <>
            <Drawers />
          </>
        ) : (
          <>
            <Box
              sx={{
                bgcolor: "#2E1834",
                py: 0.5,
                margin: "0 auto",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div className="">
                  <div className="">
                    <Typography
                      sx={{
                        fontWeight: 400,
                        color: "#fff",
                        fontSize: "12px",
                        display: { lg: "block", md: "block", xs: "none" },
                      }}
                    >
                      Shop & Sell on the go!
                      <Link
                        className="ml-3"
                        to="#"
                        onClick={handleDownloadApp}
                        style={{
                          color: "#ffffff",
                          fontWeight: 700,
                        }}
                      >
                        Download Mamaket App
                      </Link>
                    </Typography>
                  </div>
                </div>
              </Box>
            </Box>

            <div className="bg-[#2E1834] h-[70px] w-full pt-4 pb-4">
              <Box
                sx={{
                  margin: "0 auto",
                  width: {
                    xl: "75%",
                    lg: "85%",
                    md: "85%",
                    sm: "90%",
                    xs: "90%",
                  },
                }}
              >
                <div className="w-full flex gap-x-20 justify-between items-center  ">
                  {/* Logo and Location */}
                  <div className="flex items-center gap-x-10">
                    <Logo variant="text" width="150" />
                    {/* Location */}
                    <PostalCode />
                  </div>

                  {/* FULL SEARCHBAR */}
                  <div className="flex-1">
                    <EnhancedSearchDropdown
                      placeholder="Search culture, products, services, events, etc."
                      onSearch={(searchQuery) => setQuery(searchQuery)}
                      value={query}
                      enableNavigation={true}
                      style={{
                        textField: {
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#fff",
                            },
                          },
                        },
                      }}
                    />
                  </div>

                  {/* QUICK ACTIONS */}

                  <div>
                    {isAuthenticated ? (
                      <>
                        <div className="flex items-center gap-x-6">
                          <Link to="/ma-agent">
                            <div className="flex items-center gap-x-2 cursor-pointer">
                              <img
                                alt="ai_icon"
                                src={aiIcon}
                                className="w-5 h-5"
                              />
                              {/* <span className="text-[14px]">Ask Ma</span> */}
                            </div>
                          </Link>

                          <div
                            onClick={handleCartDrawerOpen}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="shopping_cart_icon"
                                src={shoppingCartIcon}
                                className="w-5 h-5"
                              />
                              {cartCount > 0 && (
                                <CartActionBadge>
                                  {cartCount > 99 ? "99+" : cartCount}
                                </CartActionBadge>
                              )}
                            </Box>
                          </div>
                          <div
                            onClick={handleWishDrawerOpen}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                alt="shopping_cart_icon"
                                src={wishListIcon}
                                className="w-5 h-5"
                              />
                              {favItems?.favItemsVar?.length > 0 && (
                                <CartActionBadge>
                                  {favItems?.favItemsVar?.length > 99
                                    ? "99+"
                                    : favItems?.favItemsVar?.length}
                                </CartActionBadge>
                              )}
                            </Box>
                          </div>

                          <div
                            onClick={handleClick}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <img
                              alt="login_icon"
                              src={loginIcon}
                              className="w-5 h-5"
                            />
                            <span className="text-[14px]">
                              {" "}
                              {userInfo
                                ? `${userInfo?.firstName} ${userInfo?.lastName}`
                                : "My Account"}
                            </span>
                            <FaChevronDown
                              style={{
                                color: "#fff",
                                fontSize: "12px",
                              }}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex items-center gap-x-6">
                          <div
                            onClick={() => triggerAuth("signin")}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <img
                              alt="ai_icon"
                              src={aiIcon}
                              className="w-5 h-5"
                            />
                            {/* <span className="text-[14px]">Ask Ma</span> */}
                          </div>

                          <div
                            onClick={() => triggerAuth("signin")}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <img
                              alt="shopping_cart_icon"
                              src={shoppingCartIcon}
                              className="w-5 h-5"
                            />
                          </div>
                          <div
                            onClick={() => triggerAuth("signin")}
                            className="flex items-center gap-x-2 cursor-pointer"
                          >
                            <img
                              alt="shopping_cart_icon"
                              src={wishListIcon}
                              className="w-[18px] h-[18px]"
                            />
                          </div>
                          <div className="flex items-center gap-x-3">
                            <div
                              onClick={() => triggerAuth("signin")}
                              className="flex items-center gap-x-2 cursor-pointer"
                            >
                              <img
                                alt="login_icon"
                                src={loginIcon}
                                className="w-5 h-5"
                              />
                              <span className="text-[14px]">Login</span>
                            </div>
                            |
                            <div
                              onClick={() => triggerAuth("signup")}
                              className="flex items-center gap-x-2 cursor-pointer"
                            >
                              <span className="text-[14px]">Register</span>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Box>
            </div>

            <Box></Box>
          </>
        )}
        {!mini && <FullSearchBar />}
      </AppBar>

      <Box sx={{ height: { md: "170px", sm:mini ? "110px" : "250px", xs:mini ? "110px" : "250px" } }}></Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            border: `1px solid ${COLORS.BORDER_GREY}`,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            width: "200px",
          }}
        >
          <Link to="/account">
            <Box
              sx={{
                borderBottom: "1px solid",
                borderColor: COLORS.BORDER_GREY,
                px: 2,
                py: 1,
                color: "#333",
                fontSize: { md: "16px", xs: "14px" },
                fontWeight: 500,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  color: COLORS.TEXT_BLACK,
                  fontSize: "14px",
                }}
              >
                {`${userInfo?.firstName} ${userInfo?.lastName}`}
              </Typography>
              <Typography>{userInfo?.email}</Typography>
            </Box>
          </Link>
          <Link to={"/account"}>
            <MenuItem
              sx={{
                mb: 0.4,
                color: COLORS.TEXT_BLACK,
                fontSize: "14px",
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
                columnGap: 1,
              }}
            >
              <FiUser style={{ fontSize: "17px" }} />
              My Profile
            </MenuItem>
          </Link>
          <Link to={isSeller ? "/sell-on-mamaket" : "/become-a-seller"}>
            <MenuItem
              sx={{
                mb: 0.4,
                color: "#333",
                fontSize: "14px",
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
                columnGap: 1,
              }}
            >
              <img src={sellIcon} width={18} />
              Sell on Mamaket
            </MenuItem>
          </Link>
          <Link to="/account/mamapurse">
            <MenuItem
              sx={{
                mb: 0.4,
                color: "#333",
                fontSize: "14px",
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
                columnGap: 1,
              }}
            >
              <img src={wallet} width={18} />
              Mamapurse
            </MenuItem>
          </Link>
          <Link to="/account/orders">
            <MenuItem
              sx={{
                borderBottom: "1px solid #F8F7F7",
                pb: 2,
                color: "#333",
                fontSize: "14px",
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
                columnGap: 1,
              }}
            >
              <img src={box} width={18} />
              My Order
            </MenuItem>
          </Link>
          <Box
            onClick={handleLogOut}
            sx={{
              px: 2,
              display: "flex",
              alignItems: "center",
              columnGap: 1,
              py: 1,
              cursor: "pointer",
            }}
          >
            <MdOutlineLogout style={{ color: COLORS.DANGER }} />
            <Typography
              onClick={handleLogOut}
              sx={{
                color: COLORS.DANGER,
                textAlign: "left",

                fontSize: "14px",
                fontWeight: 400,
              }}
              fullWidth
            >
              Log out
            </Typography>
          </Box>
        </Box>
      </Popover>

      {/* Cart Drawer */}
      <CartDrawer open={cartDrawerOpen} onClose={handleCartDrawerClose} />
      <WishlistDrawer open={wishDrawer} onClose={() => setWishDrawer(false)} />
    </>
  );
};

export default Navbar;

export const NavIconButton = ({ children, onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        borderRadius: "8px",
        width: "45px",
        height: "43px",
        "&:hover": {
          bgcolor: COLORS.DISABLED,
          color: COLORS.WHITE,
        },
      }}
    >
      {children}
    </IconButton>
  );
};

//  const { triggerAuth } = useAuthFlow();
//  onClick={()=>triggerAuth("signin")}
